export default from './block-confirmation';



// WEBPACK FOOTER //
// ./app/components/block-confirmation/index.js